import styles from './LoginFooter.module.css';
import { getEnvConfig } from '@/config/env';

export function LoginFooter() {
  const { zendeskUrl } = getEnvConfig();

  const handleContinue = () => {
    window.open(zendeskUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        <span>© 2026 Happy Days Tech</span>

        <a
          href="mailto:ayuda@delt.ai"
          className={styles.link && styles.fullText}
        >
          Contáctanos con un correo a <b>ayuda@delt.ai</b>
        </a>

        <a
          href="mailto:ayuda@delt.ai"
          className={styles.link && styles.mobileOnly}
        >
          <b>ayuda@delt.ai</b>
        </a>

        <a
          onClick={handleContinue}
          className={styles.link}
        >
          Centro de Ayuda
        </a>
      </div>

      <button
        className={styles.chatButton}
        aria-label="Ayuda"
        onClick={() => {
          // Open chat / soport
        }}
      >
        💬
      </button>
    </footer>
  );
}
